import { type Role, isAdminRole } from './IRoleRepository'

export interface UserFormData {
    fullName: string
    email: string
    warehouse?: string
    password?: string
    confirm_password?: string
}

export class UserValidator {
    static validate(
        formData: UserFormData,
        role: Role | undefined,
        mode: 'create' | 'edit'
    ): boolean {
        const {
            fullName,
            email,
            warehouse,
            password = '',
            confirm_password = '',
        } = formData

        if (fullName.trim() === '' || email.trim() === '' || role === undefined) {
            return false
        }

        const isWarehouseRequired = role && !isAdminRole(role.name)
        if (isWarehouseRequired && (warehouse === undefined || warehouse === '')) {
            return false
        }

        if (mode === 'create') {
            if (password.trim() === '' || password !== confirm_password) {
                return false
            }
        } else {
            // mode === 'edit'
            if (password.trim() !== '' && password !== confirm_password) {
                return false
            }
        }

        return true
    }
}
